export enum PanelType {
  FieldPanel = 'FieldPanel',
  TablePanel = 'TablePanel'
}
